// features/common/DatePicker.js

// This is a custom component to help reduce the amount time I have to go through and make each date picker look the same and keep me from having to remember all the things I need to.

import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { parseLocalDate } from "../../utils/dateUtils";
// Custom date picker component for dealing with styling

export const customDatePicker = ({ className, children }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 9999,
        backgroundColor: "white",
        padding: "1em",
        borderRadius: "8px",
        border: "2px solid #000000",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        fontSize: "1em",
        display: "inline-block",
        width: "auto",
        minWidth: "320px",
      }}
    >
      <div className={className}>{children}</div>
    </div>
  );
};

// Custom input component for DatePicker with icon
const CustomDateInput = React.forwardRef(
  ({ value, onClick, placeholder, disabled, className, id }, ref) => {
    const containerStyle = {
      position: "relative",
      display: "inline-block",
      width: "100%",
      minHeight: "30px",
    };

    const inputStyle = {
      paddingLeft: "2.5rem",
      paddingRight: "0.5rem",
      padding: "5px 0.5rem 5px 2.5rem",
      width: "100%",
      boxSizing: "border-box",
      cursor: disabled ? "not-allowed" : "pointer",
      minHeight: "30px",
      fontSize: "16px",
      border: "2px solid #000000",
      borderRadius: "4px",
    };

    const iconStyle = {
      position: "absolute",
      left: "0.5rem",
      top: "50%",
      transform: "translateY(-50%)",
      pointerEvents: "none",
      fontSize: "1.2rem",
      color: "#666",
      zIndex: 0,
    };

    return (
      <div style={containerStyle}>
        <span style={iconStyle}>📅</span>
        <input
          type="text"
          value={value || ""}
          onClick={onClick}
          placeholder={placeholder}
          disabled={disabled}
          readOnly
          ref={ref}
          style={inputStyle}
          className={className}
          id={id}
        />
      </div>
    );
  }
);

CustomDateInput.displayName = "CustomDateInput";

export const DelDatePicker = ({
  selected = null,
  onChange,
  isDisabled = false,
  id = null,
  className = null,
  placeholderText = "Select a date",
  withPortal = true,
  portalId = "date-picker-portal",
  dateFormat = "MM/dd/yyyy",
  wrapperClassName = null,
  calendarClassName = null,
  calendarContainer = customDatePicker,
  popperClassName = null,
  onFocus = (e) => (e.target.readOnly = true),
  // Adding filter dates start and end options
  minDate = null,
  maxDate = null,
  startDate = null,
  endDate = null,
  ...rest
}) => {
  return (
    <DatePicker
      closeOnScroll
      selected={parseLocalDate(selected)}
      onChange={onChange}
      disabled={isDisabled}
      customInput={
        <CustomDateInput
          placeholder={placeholderText}
          disabled={isDisabled}
          className={className}
          id={id}
        />
      }
      placeholderText={placeholderText}
      popperClassName={popperClassName}
      shouldCloseOnSelect={true}
      calendarContainer={calendarContainer}
      withPortal={withPortal}
      portalId={portalId}
      onFocus={onFocus}
      wrapperClassName={wrapperClassName}
      calendarClassName={calendarClassName}
      dateFormat={dateFormat}
      isClearable={true}
      showPopperArrow={false}
      minDate={parseLocalDate(minDate)}
      maxDate={parseLocalDate(maxDate)}
      startDate={parseLocalDate(startDate)}
      endDate={parseLocalDate(endDate)}
      {...rest}
    />
  );
};

export const SamplingEventDatePicker = ({
  selected = null,
  onChange,
  isDisabled = false,
  id = null,
  className = null,
  placeholderText = "Select a date",
  withPortal = true,
  portalId = "date-picker-portal",
  dateFormat = "MM/dd/yyyy",
  wrapperClassName = null,
  calendarClassName = null,
  calendarContainer = customDatePicker,
  popperClassName = null,
  onFocus = (e) => (e.target.readOnly = true),
  // Adding filter dates start and end options
  minDate = null,
  maxDate = null,
  startDate = null,
  endDate = null,
  ...rest
}) => {
  return (
    <DatePicker
      closeOnScroll
      selected={parseLocalDate(selected)}
      onChange={onChange}
      disabled={isDisabled}
      customInput={
        <CustomDateInput
          placeholder={placeholderText}
          disabled={isDisabled}
          className={className}
          id={id}
        />
      }
      placeholderText={placeholderText}
      popperClassName={popperClassName}
      shouldCloseOnSelect={true}
      calendarContainer={calendarContainer}
      withPortal={withPortal}
      portalId={portalId}
      onFocus={onFocus}
      wrapperClassName={wrapperClassName}
      calendarClassName={calendarClassName}
      dateFormat={dateFormat}
      isClearable={true}
      showPopperArrow={false}
      minDate={parseLocalDate(minDate)}
      maxDate={parseLocalDate(maxDate)}
      startDate={parseLocalDate(startDate)}
      endDate={parseLocalDate(endDate)}
      {...rest}
    />
  );
};
